import { render, staticRenderFns } from "./TqTabs.vue?vue&type=template&id=246633ed&scoped=true&"
import script from "./TqTabs.vue?vue&type=script&lang=js&"
export * from "./TqTabs.vue?vue&type=script&lang=js&"
import style0 from "./TqTabs.vue?vue&type=style&index=0&id=246633ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246633ed",
  null
  
)

export default component.exports